import type { PageContext } from 'vike/types';

// Homepage title. Falls back to the brand name from the resolved
// siteConfig (so ScoreMore homepage unfurls show "ScoreMore Travel"
// rather than the generic "Nonprofit Trips" baked into the global
// +config.ts default).
const DEFAULT_TITLE = 'Nonprofit Trips — Book hotels at the same prices and fund your cause';

export default (pageContext: PageContext): string => {
   const site = (pageContext as unknown as {
      site?: { displayName?: string; visualBranding?: { seo?: { defaultTitle?: string } } };
   }).site;
   const seoDefault = site?.visualBranding?.seo?.defaultTitle?.trim();
   if (seoDefault) return seoDefault;
   const displayName = site?.displayName?.trim();
   return displayName
      ? `${displayName} — Book hotels at the same prices and fund your cause`
      : DEFAULT_TITLE;
};
